import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertISOToYMD } from "../../../utils";
import { storeNewsApi } from "../api/storeNewsApi";
import { findNews } from "../../../modules/reducers/storeNews/storeNews";
import { getBranchListApi } from "../api/getBranchListApi";
import { findBranches } from "../../../modules/reducers/storeNews/getBranchesStoreNews";
import useReactGASend from "../../../hooks/useReactGASend";

const useStoreNewsSearch = () => {
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const loading = useSelector((state) => state.storeNews.loading);
  const loaded = useSelector((state) => state.storeNews.loaded);
  const newsList = useSelector((state) => state.storeNews.newsList);
  const branchList = useSelector(
    (state) => state.getBranchesStoreNews.branchList
  );
  const brandId = useSelector((state) => state.checkArsStatus.brandId);

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    keyword: "",
    status: "ongoing",
    selectedBranchId: null,
  });
  const [activeTab, setActiveTab] = useState("행사진행중");
  const [filteredNewsList, setFilteredNewsList] = useState([]);
  const { makeEventTrackFn } = useReactGASend();

  const categories = {
    행사진행중: "ongoing",
    행사예정: "upcoming",
  };
  const categoryKeys = Object.keys(categories);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setFormData((prev) => ({
      ...prev,
      status: categories[tab],
    }));
    clearInput();
    // setTimeout(() => {
    //   window.scrollTo(0, 0);
    // }, 100);
  };

  const clearInput = () => {
    setFormData((prev) => ({
      ...prev,
      keyword: "",
    }));
  };

  const search = () => {
    const api = storeNewsApi({
      date: convertISOToYMD(new Date()),
      branchId: formData.selectedBranchId,
    });
    dispatch(findNews(api));
  };

  const selectBranch = (branchId) => {
    setFormData((prev) => ({
      ...prev,
      selectedBranchId: branchId,
      status: "ongoing",
    }));
    setActiveTab("행사진행중");
  };

  const filterNewsList = () => {
    const filtered = newsList.filter((news) => {
      const matchesKeyword =
        formData.keyword === "" ||
        news?.title.includes(formData.keyword) ||
        news?.gcode_name.includes(formData.keyword);
      const matchesStatus =
        (formData.status === "ongoing" && news.status === "운영중") ||
        (formData.status === "upcoming" && news.status === "예정");
      return matchesKeyword && matchesStatus;
    });
    setFilteredNewsList(filtered);
  };

  useEffect(() => {
    const api = getBranchListApi({
      brandId,
    });
    dispatch(findBranches(api));
  }, []);

  useEffect(() => {
    search();
  }, [formData]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      selectedBranchId: branchList[0]?.id,
    }));
  }, [branchList]);

  useEffect(() => {
    if (branchId) {
      setFormData((prev) => ({
        ...prev,
        selectedBranchId: branchId,
      }));
      search();
    }
  }, [branchId]);

  useEffect(() => {
    filterNewsList();
  }, [formData.keyword, formData.status, newsList]);

  // 초기 필터링을 위해 처음에 한번 실행
  useEffect(() => {
    filterNewsList();
  }, [newsList]);

  return {
    formData,
    handleChange,
    search,
    activeTab,
    handleTabClick,
    categoryKeys,
    clearInput,
    loading,
    loaded,
    branchList,
    selectBranch,
    filteredNewsList,
  };
};

export default useStoreNewsSearch;
